

import React from 'react';

import './premium-lockbox.scss';
import Chevron from './../../images/chevron.png';

import Lock from './../../images/lock.svg';


const PremiumLockbox = ({ setPremiumModalOpen, modalText }) => {


    return (
        <>
            <div className="lockbox-container">
                <div className="lockbox" >

                    <div className="lockbox-image">
                        <img className="lockbox-icon" src={Lock} alt="lock" />
                    </div>

                    {modalText}

                    <div className="button-container" onClick={()=>{setPremiumModalOpen(true)}}>
                        <button className="button secondary">
                            <div className="button-text">
                                Unlock full results
                            </div>
                            <img className="button-icon" src={Chevron} alt="chevron" />
                        </button>
                    </div>

                </div>
            </div>

        </>

    );






}

export default PremiumLockbox;